module.exports = __webpack_public_path__ + "static/media/Dog on bed.d5682b88.svg";